import { useEffect } from 'react';

const DEFAULT_TITLE = 'NoteSwapp — Share Notes. Discover Better Study Materials.';
const DEFAULT_DESCRIPTION =
  'NoteSwapp helps students exchange lecture notes in a fair, organized, and reliable way — powered by AI-assisted quality checks.';

export default function PageMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDescription = meta?.getAttribute('content') ?? DEFAULT_DESCRIPTION;

    if (title) document.title = title;
    if (description && meta) meta.setAttribute('content', description);

    return () => {
      document.title = prevTitle || DEFAULT_TITLE;
      if (meta) meta.setAttribute('content', prevDescription || DEFAULT_DESCRIPTION);
    };
  }, [title, description]);

  return null;
}
